import React, { Component } from 'react';
import Sound from 'react-sound';
import { connect } from 'react-redux';
import axios from 'axios';
import { finishSpeaking, setCurrentLine, setData } from '../../redux/actions/text.action';
import { detect } from 'detect-browser';

const browser = detect();
const issueTokenURL = "https://westeurope.api.cognitive.microsoft.com/sts/v1.0/issuetoken";
const ocpapimsubKey = "ff2986e3bb594763b15dff12edb9939d";

class Text2Voice extends Component<{ finishedSpeaking: any, textArray: any, setCurrentLine: any, data: any, setData: any, alreadyPlayed: boolean, gender: any, voice: any, text: string, playing?: boolean, callback: any }, {}> {
  private index = 0;
  state = {
    playing: false
  }
  constructor(props: any) {
    super(props);
    if (this.props.text !== this.props.text && this.props.text !== "") {
      //   this.speak(this.props.text);
    }
    if (this.props.textArray.length > 0) {
      this.speak(this.props.textArray[0]);
    }
  }

  componentDidMount() {
    // this.speak(this.props.textArray[0]);
  }


  speak(text: string) {
    console.log(text);
    let gender = this.props.gender ? this.props.gender : "Male";
    let voice = this.props.voice ? this.props.voice : "de-AT-Michael";
    let prefix = "<speak version='1.0' xml:lang='de-DE'><voice xml:lang='de-DE' xml:gender='" + gender + "'\n name='" + voice + "'>\n";
    let suffix = "\n</voice></speak>";

    axios.post(issueTokenURL, {}, {
      headers: {
        "Ocp-Apim-Subscription-Key": ocpapimsubKey
      }
    }).then((result: any) => {
      axios.post('https://westeurope.tts.speech.microsoft.com/cognitiveservices/v1', prefix + text + suffix, {
        method: 'POST',
        responseType: 'blob',
        headers: {
          "Content-Type": "application/ssml+xml",
          "X-Microsoft-OutputFormat": "audio-16khz-64kbitrate-mono-mp3",
          "Authorization": "Bearer " + result.data,
        }
      }).then((response) => {
        this.props.setCurrentLine(text);
        this.props.setData(URL.createObjectURL(response.data));
        if (browser && (browser && browser.name !== 'safari' && browser.name !== 'ios')) {
          this.setState({ playing: true });
        }

      });
    }).catch(err => console.log(err));
  }

  render() {
    console.log(this.props.data)
    const isApple = (browser && browser.name !== 'safari' && browser.name !== 'ios');
    return (
      <div>
        <Sound
          url={this.props.data}
          autoload={!isApple}
          playStatus={(this.state.playing || this.props.playing) ? Sound.status.PLAYING : Sound.status.STOPPED}
          onFinishedPlaying={() => {
            this.props.setData(null);
            this.index++;
            if (this.props.textArray && this.index < this.props.textArray.length && browser && (browser && browser.name !== 'safari' && browser.name !== 'ios')) {
              if (this.index < this.props.textArray.length) {
                this.speak(this.props.textArray[this.index]);
              }
            }
            this.props.setCurrentLine("");
            this.props.finishedSpeaking();
            if (this.props.callback && this.index == this.props.textArray.length) {
              this.props.callback();
            }
          }
          }
          onError={(errorCode: any, description: any) => {
            console.log("KACKE");
          }}
        />
      </div>
    )
  }
}


const mapStateToProps = (state: any) => {
  return {
    text: state.texttospeech.textToSpeak,
    //textArray: state.texttospeech.pageText,
    data: state.texttospeech.data,
    alreadyPlayed: state.texttospeech.alreadyPlayed,
    gender: state.avatar.avatarGender,
    voice: state.avatar.avatarVoice
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    finishedSpeaking() {
      //  dispatch(finishSpeaking());
    },
    setCurrentLine(text: string) {
      dispatch(setCurrentLine(text));
    },
    setData(data: any) {
      dispatch(setData(data));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Text2Voice);